import { useState } from "react"
import { useCurrentTripContext } from '../hooks/useCurrentTripContext'
import { useAuthContext } from '../hooks/useAuthContext'

import TripAddActivity from './TripAddActivity'
import TripUpdateActivity from './TripUpdateActivity'

const TripItinerary = ({trip, activities}) => {
    const { dispatch } = useCurrentTripContext()
    const { user } = useAuthContext()
    const [selected_date, setSelectedDate] = useState(trip.trip_start_date)
    const [pageDisplay, setPageDisplay] = useState("details")
    const [selectedActivity, setSelectedActivity] = useState(null)

    const handleClick = async (e, activity) => {
        e.preventDefault()
        e.stopPropagation()
        if (!user) {
            return
        }
        
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/activity/`, {
            method: 'DELETE',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({trip_id: trip._id, activity_id: activity._id}),
            credentials: 'include'
        })
        const json = await response.json()
        if (response.ok) {
            dispatch({type: 'DELETE_ACTIVITY', payload: json})
        }
    }

    const calculateDays = () => {
        const startDate = new Date(trip.trip_start_date);
        const endDate = new Date(trip.trip_end_date);
        const timeDifference = endDate - startDate;
        const dayDifference = Math.ceil(timeDifference / (1000 * 3600 * 24) + 1);
        return dayDifference;
    }

    const totalDays = calculateDays();

    const getArrayDates = () => {
        const array = [];
        for (let i = 0; i < totalDays; i++) {
            var date = new Date(trip.trip_start_date);
            date.setDate(date.getDate() + i);
            array.push(date.toISOString().slice(0, 10))
        }
        return array;
    }

    const tripDateArray = getArrayDates()

    return (
        <div className="itinerary-page-container">
            <div className="itinerary-page-content-container">
                <div className="itinerary-dates">
                    {tripDateArray.map((date, i) => (
                        <div key={i} className={`trip-date ${selected_date === date ? "trip-date-selected" : ""}`} onClick={() => {
                            setSelectedDate(date)
                            setPageDisplay("details")
                        }}>
                            {date}
                        </div>
                    ))}
                </div>
                <div className="activities-container">
                    {pageDisplay === "details" && (
                    <div className="activity-details-page">
                        <div className="activities-header">
                            <h3>Current Activities for {selected_date}</h3>
                        </div>
                        <div className="add-activity-btn-container">
                            <button className="add-activity-btn" onClick={() => setPageDisplay("add")}>Add Activity</button>
                        </div>
                        <div className="activity-list">
                            {activities && activities.filter(a => a.activity_date === selected_date).map(a => (
                                <div className="activity-list-item" key={a._id} onClick={(e) => {
                                    setSelectedActivity(a)
                                    setPageDisplay('edit')
                                }}>
                                    <p><strong>{a.activity_type}</strong></p>
                                    <p><strong>Where: </strong><a href={a.location_link} target="_blank" rel="noreferrer">{a.location_name}</a></p>
                                    <p><strong>When: </strong>{a.start_time} - {a.end_time}</p>
                                    {a.additional_details && <p><strong>Additional Details: </strong>{a.additional_details}</p>}
                                    <span className="material-symbols-outlined" onClick={(e) => {handleClick(e, a)}}>delete</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    )}
                    {pageDisplay === "add" && <TripAddActivity trip={trip} activity_date={selected_date} setPageDisplay={setPageDisplay} />}
                    {pageDisplay === "edit" && <TripUpdateActivity trip={trip} activity={selectedActivity} activity_date={selected_date} setPageDisplay={setPageDisplay} />}
                </div>
            </div>
        </div>
    )
}

export default TripItinerary

